/* Movatic WMS — Frontend | CesarFilho 932048016
 * Arquivo: src/components/KpiCard.tsx
 */
import React from 'react'

export default function KpiCard({
    label, value, hint
}: { label: string; value: React.ReactNode; hint?: string }) {
    return (
        <div className="rounded-xl border border-neutral-200 dark:border-neutral-800 p-4 bg-white dark:bg-neutral-950">
            <div className="text-xs uppercase tracking-wide text-neutral-500">{label}</div>
            <div className="mt-1 text-2xl font-semibold">{value}</div>
            {hint ? <div className="mt-1 text-[13px] text-neutral-500">{hint}</div> : null}
        </div>
    )
}
